/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module TrafficCloneProfileModule
 */

const moduleName = 'traffic-clone-profile';
const componentName = 'traffic-clone-profile-page';
const prefix = `${moduleName}.${componentName}`;

export const headerLabel = `${prefix}.headerLabel`;
export const placeholderMessage = `${prefix}.placeholderMessage`;

export const ENGLISH = {
    [headerLabel]: 'Traffic Clone Profile',
    [placeholderMessage]: 'No Items Found',
};
